import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export const LoadingContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`;

export const Header = styled.div`
	padding: 8px 32px;
	display: flex;
	align-items: center;
	width: 100%;
	border-bottom: 1px solid ${colors.grey3};
`;

export const RightSection = styled.div`
	margin-left: auto;
	display: flex;
	align-items: center;
`;

export const InputWrapper = styled.div`
	width: 88px;
	min-width: 88px;

	input {
		min-width: 88px;
	}
`;

export const DpoWrapper = styled.div`
	max-width: 320px;
	display: flex;
	align-items: center;
	width: 100%;

	${InputWrapper} {
		width: 80px;
		min-width: 80px;

		input {
			min-width: 80px;
		}
	}
`;

export const SearchWrapper = styled.div`
	position: absolute;
	width: 460px;
	padding: 9px 32px;
	bottom: 0;
`;

export const IconWrapper = styled.div`
	height: 16px;
	width: 16px;
	margin-left: 6px;
`;

export const TooltipContent = styled.div`
	text-align: left;
`;

export const Label = styled.div`
	font-size: 13px;
	line-height: 19px;
	color: black;
	letter-spacing: 0.3px;
	padding-right: 8px;
`;

export const RangeWrapper = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	padding: 0 16px;

	.rc-slider {
		.rc-slider-track {
			background-color: ${colors.green1};
		}

		.rc-slider-handle {
			background-color: ${colors.green1};
			border-color: ${colors.green1};
			opacity: 1;
			width: 16px;
			height: 16px;
			margin-top: -6px;

			&:focus {
				box-shadow: 0 0 0 3px rgb(92, 179, 53, 0.4);
				border-color: ${colors.green1};
			}

			&.rc-slider-handle-dragging {
				box-shadow: 0 0 0 6px rgb(92, 179, 53, 0.4);
			}
		}
	}
`;

export const Divider = styled.div`
	border-left: 1px solid ${colors.grey2};
	height: 32px;
	margin: 0 16px;
	align-self: center;
`;

export const NoData = styled.div`
	color: ${colors.grey7};
	font-size: 16px;
	letter-spacing: 0.3px;
	text-align: center;
	padding: 16px;
`;
